/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

export const TAB_IDS = {
  INSTRUCTIONS: "instructions-tab",
  GENERAL_PARAMETERS: "general-parameters-tab",
  INITIAL_ASSETS: "initial-assets-tab",
  FINAL_ASSETS: "final-assets-tab",
  CASH_FLOWS: "cash-flows-tab",
  SAVE_LOAD: "save-load-tab",
  RESULTS: "results-tab",

  // Results inner tabs
  FAILURE_RATES: "failure-rates-tab",
  CONSUMPTION_AMOUNTS: "consumption-amounts-tab",
  CONSUMPTION_RATES: "consumption-rates-tab",
  FINAL_VALUES: "final-values-tab",
  ABOUT_RESULTS: "about-results-tab",
}

// The ordered tabs for navigation with errors
export const ORDERED_PARAMETER_TABS = [
  TAB_IDS.GENERAL_PARAMETERS,
  TAB_IDS.INITIAL_ASSETS,
  TAB_IDS.FINAL_ASSETS,
  TAB_IDS.CASH_FLOWS,
]
